import { render, staticRenderFns } from "./DomainNameDisable.vue?vue&type=template&id=abfe9012&scoped=true&"
import script from "./DomainNameDisable.vue?vue&type=script&lang=js&"
export * from "./DomainNameDisable.vue?vue&type=script&lang=js&"
import style0 from "./DomainNameDisable.vue?vue&type=style&index=0&id=abfe9012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfe9012",
  null
  
)

export default component.exports